import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router';
import {
  RaisedButton,
  List,
  ListItem,
  IconButton,
  DatePicker
} from 'material-ui';
import * as SvgIcons from '../Material/SvgIcons';
import Loader from '../Material/Loader';
import SearchBar from "../SearchBar";
import MaterialDropDown from '../Material/DropDown';
import { _l } from 'oxygen-i18n';
import moment from 'moment';

addTranslations({
  'en-US': {
    All: 'All',
    Active: 'Active',
    Inactive: 'Inactive',
    'Search for students': 'Search for students',
  },
  'sv-SE': {
    All: 'Alla',
    Active: 'Aktiva',
    Inactive: 'Inaktiva',
    'Search for students': 'Sök studenter på namn/epost',
  },
});

const minDate = new Date();
const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() + 2);

class StudentOverview extends Component {
  static propTypes = {
    list: PropTypes.array,
    prevDisabled: PropTypes.bool,
    nextDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    prev: PropTypes.func,
    next: PropTypes.func,
    filter: PropTypes.func,
    filterByStatus: PropTypes.func,
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      student: {},
    };
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.list !== this.props.list ||
      nextProps.loading !== this.props.loading
    );
  }

  formatDate = date => moment(date).format('YYYY-MM-DD');

  onClickDatePicker = (event, item) => {
    event.stopPropagation();
    this.setState({ student: item });
  };

  onTouchTapRightIcon = (event, item) => {
    event.stopPropagation();
    if (this.props.onTouchTapRightIcon) {
      this.props.onTouchTapRightIcon(item);
    }
  };

  changeAccessDate = (foo, accessDate) => {
    accessDate.setHours(12);
    if (this.props.onTouchTap) {
      this.props.onTouchTap(this.state.student, accessDate);
    }
  };

  goToStudent = (item) => {
    if (item === null) {
      this.setState({ student: null });
    } else {
      this.props.router.push(`/student/${item.id}`);
    }
  };

  handleFilterByStatus(event) {
    this.props.filterByStatus(event.target.value);
  }

  render() {
    const {
      list,
      prevDisabled,
      nextDisabled,
      prev,
      next,
      filter,
      loading,
      total,
      pageStartStudents,
      pageLengthStudents
    } = this.props;

    let count = list.length + pageStartStudents;
    if (pageStartStudents === 0 && total < pageLengthStudents) {
      count = total;
    }

    let buttons = null;
    if (total >= pageLengthStudents && pageLengthStudents <= list.length) {
      buttons = (
        <div>
          {loading ? <Loader /> : null}
          <RaisedButton
            label={'prev'}
            disabled={prevDisabled}
            onTouchTap={prev}
          />
          <RaisedButton
            label={'next'}
            disabled={pageStartStudents + pageLengthStudents > total}
            onTouchTap={next}
          />
        </div>
      );
    }

    const subHeader = (
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <span>Students ({count}/{total})</span>
        <span style={{fontSize: '0.6em'}}>
          <MaterialDropDown
            onChange={::this.handleFilterByStatus}
            label="Filter by status"
            menuItems={[
              {
                payload: null,
                text: _l`All`,
              },
              {
                payload: 1,
                text: _l`Active`,
              },
              {
                payload: 0,
                text: _l`Inactive`,
              },
            ]}
          />
        </span>
      </div>
    );

    return (
      <List
        subheader={subHeader}
        style={{ marginTop: '10px', backgroundColor: '#FFFFFF' }}
        subheaderStyle={{
          fontSize: 24,
          borderStyle: 'none none solid none',
          borderWidth: '1px',
          borderColor: 'rgba(0, 0, 0, 0.12)'
        }}
      >
        <SearchBar fullWidth onChange={filter} placeholder={_l`Search for students`}/>

        {list.map(item => {
          let expiration = null;
          if (item.expires === '0000-00-00') {
            expiration = 'Forever';
          } else {
            expiration = item.expires;
          }

          return (
            <ListItem
              key={item.id}
              primaryText={item.name}
              leftIcon={
                <IconButton
                  onTouchTap={event => this.onTouchTapRightIcon(event, item)}
                  tooltip={this.context.getIntlMessage(
                    'student.removeFromCourse'
                  )}
                  tooltipPosition="top-right"
                >
                  <SvgIcons.ContentClear />
                </IconButton>
              }
              rightIcon={
                <IconButton onTouchTap={event => this.onClickDatePicker(event, item)} style={{ didFlip: false, right: '200px', top: '-10px' }}>
                  <DatePicker
                    hintText={
                      this.context.getIntlMessage('course.access') + expiration
                    }
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={this.changeAccessDate.bind(this)}
                    formatDate={this.formatDate}
                    textFieldStyle={{ width: '210px', fontSize: '15px' }}
                    inputStyle={{ cursor: 'pointer' }}
                  />
                </IconButton>
              }
              onTouchTap={() => this.goToStudent(item)}
            />
          );
        })}

        {buttons}
      </List>
    );
  }
}

export default withRouter(StudentOverview);



// WEBPACK FOOTER //
// ./src/js/components/Student/StudentOverview.js